module.exports = __webpack_public_path__ + "img/default-female.eccb842c.png";